export default `
precision highp float;
uniform vec4 uColor;
void main(void) {
    gl_FragColor = uColor; 
}
`;
//# sourceMappingURL=lineFragmentShader.js.map